import { useCallback, useContext } from 'react';
import { toast } from 'react-toastify';
import AuthContext from '../context/authContext';
import { useHTTP } from './useHttp';

export const useAgentReports = () => {
  const authCtx = useContext(AuthContext);
  const { isLoading, error, setError, sendRequest } = useHTTP();

  const reportConversation = useCallback(
    async payload => {
      try {
        return await sendRequest({
          url: '/api/v1/agent/reported',
          method: 'POST',
          headers: authCtx.getAuthHeaders(),
          body: payload,
        });
      } catch (e) {
        toast.error('Fehler beim Melden des Vorschlags');
        throw e;
      }
    },
    [authCtx, sendRequest]
  );

  const listReportedConversations = useCallback(
    async ({ kind, status, limit = 50, skip = 0 } = {}) => {
      try {
        const params = {};
        if (kind) params.kind = kind;
        if (status) params.status = status;
        if (limit) params.limit = limit;
        if (skip) params.skip = skip;
        return await sendRequest({
          url: '/api/v1/agent/reported',
          method: 'GET',
          headers: authCtx.getAuthHeaders(),
          params,
        });
      } catch (e) {
        toast.error('Fehler beim Laden der gemeldeten Konversationen');
        throw e;
      }
    },
    [authCtx, sendRequest]
  );

  const getReportedConversationById = useCallback(
    async reportId => {
      try {
        return await sendRequest({
          url: `/api/v1/agent/reported/${reportId}`,
          method: 'GET',
          headers: authCtx.getAuthHeaders(),
        });
      } catch (e) {
        toast.error('Fehler beim Laden der Meldung');
        throw e;
      }
    },
    [authCtx, sendRequest]
  );

  const updateReportedConversationStatus = useCallback(
    async (reportId, status) => {
      try {
        return await sendRequest({
          url: `/api/v1/agent/reported/${reportId}`,
          method: 'PATCH',
          headers: authCtx.getAuthHeaders(),
          body: { status },
        });
      } catch (e) {
        toast.error('Fehler beim Aktualisieren des Status');
        throw e;
      }
    },
    [authCtx, sendRequest]
  );

  const getReportedChatSession = useCallback(
    async (reportId, { limit = 200, skip = 0 } = {}) => {
      try {
        return await sendRequest({
          url: `/api/v1/agent/reported/${reportId}/chat-session`,
          method: 'GET',
          headers: authCtx.getAuthHeaders(),
          params: { limit, skip },
        });
      } catch (e) {
        toast.error('Fehler beim Laden der Chat-Konversation');
        throw e;
      }
    },
    [authCtx, sendRequest]
  );

  return {
    isLoading,
    error,
    setError,
    reportConversation,
    listReportedConversations,
    getReportedConversationById,
    updateReportedConversationStatus,
    getReportedChatSession,
  };
};
